<template>
  <div class="media mb-0 mt-0">
    <!-- <img
      src="https://placeimg.com/640/480/animal"
      width="50px"
      class="mr-2"
      alt="..."
    /> -->
    <div class="media-body mb-0">
      <h5 class="mt-0 mb-1 font-weight-bold chat_title">New Message</h5>
      <p class="chat_name">Anda mempunyai pesan baru</p>
      <a class="text-primary" @click="toChat()">Lihat pesan</a>
    </div>
  </div>
</template>

<script>
import router from "../../router";
export default {
  methods: {
    toChat() {
      router.push({ path: "/chat" });
    },
  },
  watch: {},
  // props: ['from', 'text', 'time'],
  // props: {
  //   toChat: { type: Function },
  // },
};
</script>

<style scoped>
.chat_title {
  color: #686868;
}
.chat_name {
  color: #7c7c7c;
}
</style>